/* eslint-disable react/prop-types */
import { useState } from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { claimUsername, validateUsername } from '../lib/user';

export default function UsernameClaimModal({
  uid,
  title = 'Choose your username',
  message = "Your @username is how others find you on Loc'd In. Pick one to continue.",
  required = false,
  onSuccess,
  onClose,
}) {
  const [usernameInput, setUsernameInput] = useState('');
  const [error, setError] = useState('');
  const [claiming, setClaiming] = useState(false);

  const submit = async () => {
    const validation = validateUsername(usernameInput);
    if (validation) {
      setError(validation);
      return;
    }
    setClaiming(true);
    setError('');
    try {
      await claimUsername(uid, usernameInput, { setDisplayNameIfEmpty: true });
      onSuccess?.();
    } catch (cause) {
      setError(cause.message);
    } finally {
      setClaiming(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submit();
    }
  };

  return (
    <Modal title={title} onClose={required ? undefined : onClose}>
      <p>{message}</p>
      <label className="mt-3 block">
        <span className="mb-1 block font-bold">Username</span>
        <div className="flex items-center gap-2">
          <span className="text-subtle">@</span>
          <input
            className="field-input min-w-0 flex-1"
            value={usernameInput}
            onChange={(event) => setUsernameInput(event.target.value.toLowerCase())}
            onKeyDown={handleKeyDown}
            placeholder="username"
            maxLength="20"
            autoFocus
            autoComplete="username"
            spellCheck={false}
          />
        </div>
      </label>
      <p className="mt-2 text-sm text-subtle">3–20 lowercase letters, numbers, or underscores.</p>
      {error && <p className="form-error">{error}</p>}
      <Button className="mt-4 w-full" type="button" disabled={claiming} onClick={submit}>
        {claiming ? 'Saving…' : 'Save username'}
      </Button>
    </Modal>
  );
}
